// CAROUSEL IDENTIFIER
import {
  IMAGE_HASH,
  FILE_ID,
  FILE_NAME,
  FILE_TYPE,
  FILE_URL,
  MEDIA_DURATION,
  MEDIA_FILE_OPTION,
  MEDIA_FILE_UPLOAD,
  MEDIA_FORMAT,
  MEDIA_HEIGHT,
  MEDIA_RATIO,
  MEDIA_SIZE,
  MEDIA_TYPE,
  MEDIA_WIDTH,
  UPLOADED_MEDIA_TYPE,
  VIDEO_PICTURE
} from '../../ReusableFormFields/AdFileUpload/fields'

export const AD_PREVIEW_CAROUSEL_INDEX_KEY = 'ad_preview_carousel_index_key'
// NAME
export const NAME = 'name'
// FORMAT
export const FORMAT_OPTION = 'format_option'
export const FORMAT_SINGLE = 'format_single'
export const FORMAT_CAROUSEL = 'format_carousel'
export const FORMAT_STORY = 'format_story'
export const FORMAT_EXISTING_POST = 'format_existing_post'
// TEXT
export const TEXT_OPTION = 'text_option'
export const TEXT_ENTER = 'text_enter'
export const TEXT_BLANK = 'text_blank'
export const AD_TEXT = 'ad_text'
export const PRIMARY_TEXT_LIST = 'primary_text_list'

// СLICK THROUGH LINK
export const CLICK_THROUGH_LINK = 'click_through_link'
// HEADLINE
export const HEADLINE_OPTION = 'headline_option'
export const HEADLINE_ENTER = 'headline_enter'
export const HEADLINE_BLANK = 'headline_blank'
export const AD_HEADLINE = 'ad_headline'
export const HEADLINES_LIST = 'headlines_list'
// DESCRIPTION
export const DESCRIPTION_OPTION = 'description_option'
export const DESCRIPTION_ENTER = 'description_enter'
export const DESCRIPTION_BLANK = 'description_blank'
export const AD_DESCRIPTION = 'ad_description'
export const DESCRIPTIONS_LIST = 'descriptions_list'
// CALL-TO-ACTION
export const CALL_TO_ACTION_OPTION = 'call_to_action_option'
export const CALL_TO_ACTION_LEARN_MORE = 'call_to_action_learn_more'
export const CALL_TO_ACTION_SELECT = 'call_to_action_select'
export const CALL_TO_ACTION = 'call_to_action'
export const LEARN_MORE = 'LEARN_MORE'
// FACEBOOK
export const FB_PAGE_OPTION = 'fb_page_option'
export const FB_PAGE_SELECT = 'fb_page_select'
export const FB_PAGE_CHOICE = 'fb_page_choice'
export const INSTA_ACCOUNT_CHOICE = 'insta_account_choice'
export const INCLUDE_PARTNERSHIP_PAGE = 'include_partnership_page'
export const FB_SPONSOR_PAGE_ID = 'sponsor_page_id'
export const INSTAGRAM_ACCOUNT_SPONSOR_ID = 'sponsor_id'
// CAROUSEL
export const CAROUSEL_ITEMS = 'carousel_items'
export const CAROUSEL_ITEMS_LENGTH = 'carousel_items_length'
export const CAROUSEL_ITEM_MEDIA_FILE_ERROR = 'carousel_item_media_file_error'
// ITEM FORM
export const IS_ITEM_FORM_OPENED = 'is_item_form_focused'
//STORIES
export const STORIES_ITEMS = 'stories_items'
export const STORIES_ITEM_SELECTED_INDEX = 'stories_item_selected_index'
export const STORIES_ITEM_MEDIA_FILE_ERROR = 'stories_item_media_file_error'
// EXISTING_POST
export const EXISTING_POST = 'existing_post'

// IMAGE VALIDATION
export const IMAGE = 'image'
export const IMAGE_MAX_SIZE = 31457280 //31457280 bites = 30 MB
export const IMAGE_MIN_WIDTH = 600
export const IMAGE_MIN_HEIGHT = 600
export const IMAGE_FORMATS = ['JPG', 'jpg', 'JPEG', 'jpeg', 'PNG', 'png']
// VIDEO VALIDATION
export const VIDEO = 'video'
export const VIDEO_MAX_SIZE = 1073741824 // 1073741824 bites = 1GB
export const STORY_VIDEO_MAX_SIZE = 262144000 // 262144000 bites = 250MB
export const VIDEO_MIN_WIDTH = 120
export const VIDEO_MIN_HEIGHT = 120
export const VIDEO_FORMATS = ['MP4', 'mp4', 'MOV', 'mov', 'GIF', 'gif']
export const VIDEO_MIN_DURATION = 1
export const VIDEO_MAX_DURATION = 14460 // 241 m = 14460 s
export const STORY_VIDEO_MAX_DURATION = 3600 // 60 m = 3600 s
// MEDIA VALIDATION
export const STORY_MEDIA_MIN_WIDTH = 500
export const MEDIA_MIN_RATIO_9_16 = 0.5625 // 9:16
export const MEDIA_MAX_RATIO_16_9 = 1.78 // 16:9
export const MEDIA_MIN_RATIO_1 = 1
export const MEDIA_MIN_RATIO_4_5 = 0.8 // 4:5
export const MEDIA_MAX_RATIO_1_91 = 1.91
//URL_TAGS
export const URL_TAGS = 'url_tags'
export const URL_TAGS_OPTION = 'url_tags_option'
export const RECOMMENDED_URL_TAGS = 'recommended_url_tags'
export const CUSTOM_URL_TAGS = 'custom_url_tags'
export const NO_URL_TAGS = 'no_url_tags'
export const UTM_SOURCE = 'utm_source'
export const UTM_MEDIUM = 'utm_medium'
export const UTM_CAMPAIGN = 'utm_campaign'
export const UTM_CONTENT = 'utm_content'
export const UTM_CODES_LIST = [UTM_SOURCE, UTM_MEDIUM, UTM_CAMPAIGN, UTM_CONTENT]
// CUSTOMIZED_MEDIA
export const CUSTOMIZED_MEDIA_OPTION = 'customized_media_option'
export const UPLOAD_CUSTOMIZED_MEDIA = 'upload_customized_media'
export const NO_CUSTOMIZED_MEDIA = 'no_customized_media'
export const IS_CURRENT_MEDIA_CUSTOMIZED_WITH_STORY = 'is_current_media_customized_with_story'
export const CUSTOMIZED_STORY_FILE = 'customized_story_file'
// STATUS
export const STATUS = 'status'
// PIXEL_CHOICE
export const PIXEL_CHOICE = 'pixel_choice'
export const LEAD_GEN_FORM = 'lead_gen_form_id'

export const INSTAGRAM_ACTOR_ID = 'instagram_user_id'
export const INSTAGRAM_USER_ID = 'instagram_user_id'

export const initialFileValues = {
  [FILE_NAME]: '',
  [FILE_URL]: '',
  [FILE_TYPE]: '',
  [MEDIA_TYPE]: '',
  [IMAGE_HASH]: '',
  [FILE_ID]: '',
  [UPLOADED_MEDIA_TYPE]: ''
}
export const initialMediaValues = {
  [MEDIA_SIZE]: '',
  [MEDIA_WIDTH]: '',
  [MEDIA_HEIGHT]: '',
  [MEDIA_FORMAT]: '',
  [MEDIA_RATIO]: '',
  [MEDIA_DURATION]: '',
  [VIDEO_PICTURE]: ''
}
export const initialCarouselItem = {
  ...initialFileValues,
  // HEADLINE
  [HEADLINE_OPTION]: HEADLINE_BLANK,
  [AD_HEADLINE]: '',
  [HEADLINES_LIST]: [{ text: '' }],
  // DESCRIPTION
  [DESCRIPTION_OPTION]: DESCRIPTION_BLANK,
  [AD_DESCRIPTION]: '',
  [DESCRIPTIONS_LIST]: [{ text: '' }],
  // CALL-TO-ACTION
  [CALL_TO_ACTION]: LEARN_MORE,
  // CLICK-TROUGH-LINK
  [CLICK_THROUGH_LINK]: 'https://',
  [CAROUSEL_ITEM_MEDIA_FILE_ERROR]: '',
  [FORMAT_OPTION]: FORMAT_CAROUSEL,
  [MEDIA_FILE_OPTION]: MEDIA_FILE_UPLOAD
}
export const initialStoriesItem = {
  ...initialFileValues,
  // CALL-TO-ACTION
  [CALL_TO_ACTION]: LEARN_MORE,
  // CLICK-TROUGH-LINK
  [CLICK_THROUGH_LINK]: 'https://',
  [STORIES_ITEM_MEDIA_FILE_ERROR]: '',
  [MEDIA_FILE_OPTION]: MEDIA_FILE_UPLOAD
}
